const state = {
	data: {
		diseases_name: []
	}
}

const getters = {
	DISEASE_NAME_BY_ID : state => disease => {
		return state.data.diseases_name.find(item => {
			return item.virtual_watch_id === disease.name_id
		})
	}
}

const mutations = {
	GET_DISEASES_NAME : (state, payload) => {
		state.data.diseases_name = payload
	}
}

const actions = {
	GET_DISEASES_NAME : async (context, refThis) => {
		let { data } = await refThis.$api.profile.diseases.getNames(refThis)
		context.commit('GET_DISEASES_NAME', data)
	}
}

export default {
	state, getters, mutations, actions
}



// WEBPACK FOOTER //
// ./src/store/modules/generic.js